export default __webpack_public_path__ + "static/media/Icon material-search.24c1ac70.svg";